import { useQueryClient } from '@tanstack/react-query';
import qs from 'qs';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Verification } from '@hero/components/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import {
  useGetUser,
  useLoginWithCode,
  useSendAuthEmail,
  useSetOrganization
} from '@hero/services/organization-service/hooks';
import { getRedirectUrl, storage } from '@hero/utils';

const ValidateTemplate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const queryClient = useQueryClient();
  const { mutateAsync: sendCode } = useLoginWithCode();
  const { mutateAsync: updateOrganization } = useSetOrganization();
  const { data: userData } = useGetUser();

  const authorization = storage.getUserToken();
  const isUserAuth = authorization && userData;

  const redirect = searchParams.get('redirect');
  const externalSource = searchParams.get('externalSource');
  const email = searchParams.get('email');

  const handleSendCode = async ({ code }) => {
    const res = await sendCode({ email, code });

    queryClient.setQueryData(['user'], prev => ({
      ...prev,
      ...res.user,
      organizations: res.organizations
    }));

    if (res.organizations?.length > 1) {
      const params = qs.stringify(
        {
          from: 'login',
          redirect,
          externalSource
        },
        { addQueryPrefix: true }
      );

      navigate(`${ROUTE_PATHS.SELECT_ORGANIZATION}${params}`);
    } else if (res.organizations?.length === 1) {
      const organization = res.organizations[0];
      await updateOrganization(organization.code);

      const redirectUrl = getRedirectUrl(redirect, { externalSource });
      navigate(redirectUrl.pathname + redirectUrl.search);
    }
  };

  useEffect(() => {
    if (isUserAuth) {
      navigate(ROUTE_PATHS.HOME);
    }
  }, []);

  const { mutateAsync: sendAuthMutate } = useSendAuthEmail();

  return (
    <Verification
      contactInfo={email}
      onSubmit={handleSendCode}
      onResend={sendAuthMutate}
      onBack={() => navigate(ROUTE_PATHS.SIGN_IN)}
    />
  );
};

export { ValidateTemplate };
